import React from 'react';
import { formatCurrency } from '../../../../../../../../../CommonUtils/formatNumber';
import { Box } from '../../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../../CommonComponents/OPL/Text/Text';
import { Card } from '../../../../../../../../../CommonComponents/OPL/Card/Card';

interface Props {
  shortTerm: number;
  longTerm: number;
  total: number;
  title: string;
}

export const MobileTotals = ({ shortTerm, longTerm, total, title }: Props) => {
  return (
    <Box my="4">
      <Box display="flex" flexDirection="column" mx={16} mt={8} css="gap: 8px">
        <Card hasBorder p="12">
          <Text mb="4" variant="smallCaps" fontSize="small" color="neutral.500">
            Total Short Term Gain Loss
          </Text>

          <Text variant="tabular" fontWeight={500} fontSize="h4">
            {formatCurrency(shortTerm, { decimalPlaces: 2 })}
          </Text>
        </Card>

        <Card hasBorder p="12">
          <Text mb="4" variant="smallCaps" fontSize="small" color="neutral.500">
            Total Long Term Gain Loss
          </Text>

          <Text variant="tabular" fontWeight={500} fontSize="h4">
            {formatCurrency(longTerm, { decimalPlaces: 2 })}
          </Text>
        </Card>

        <Card hasBorder p="12">
          <Text mb="4" variant="smallCaps" fontSize="small" color="neutral.500">
            Total Gain Loss
          </Text>

          <Text variant="tabular" fontWeight={500} fontSize="h4">
            {formatCurrency(total, { decimalPlaces: 2 })}
          </Text>
        </Card>
      </Box>
    </Box>
  );
};
